import { baseApi } from "@/shared/api";
import type {
  SmetaResponse,
  InKindDonationCreateRequest,
  InKindDonationCreateResponse,
} from "../types";

export const smetaApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSmeta: builder.query<SmetaResponse, number>({
      query: (projectId) => ({
        url: `/api/accounting/smeta/?project_id=${projectId}`,
        method: "GET",
        credentials: "include" as const,
      }),
      providesTags: (_result, _error, projectId) => [{ type: "SmetaData" as const, id: projectId }],
    }),

    createInKindDonation: builder.mutation<InKindDonationCreateResponse, InKindDonationCreateRequest>({
      query: (body) => ({
        url: "/api/accounting/in-kind-donations/",
        method: "POST",
        body,
        credentials: "include" as const,
      }),
      invalidatesTags: [
        { type: "IncomeRecords" as const, id: "LIST" },
        { type: "InventoryItems" as const, id: "LIST" },
        "SmetaData",
      ],
    }),
  }),
});

export const {
  useGetSmetaQuery,
  useCreateInKindDonationMutation,
} = smetaApi;
